import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { CheckListSVTypeList, Project } from './types'

export const selectConstrucProject = (state: RootState): Project[] =>
  state.qcConstrucplan.projects

export const selectEvent = (state: RootState): Event =>
  state.qcConstrucplan.event

export const selectChecklistType = (state: RootState): CheckListSVTypeList[] =>
  state.qcConstrucplan.checkListSVTypeByProject?.ChecklistTypeList ?? []
